import React from "react";
import { Switch, Route, Router } from "./../../util/router";
import ReactPixel from "react-facebook-pixel/src/index";
import NotFoundPage from "./../not-found";
import ReportPage from "../report-page";
import "../../styles/global.scss";
import useMedia from "../../util/useQuery";
import "../../util/analytics";
import MultiStepForm from "../multi-step-form";
import SolarReport from "../solar-report";
import SolarFunnel from "../solar-funnel";
import RoofingReportPage from "../roofing-report";
import V4Report from "../v4-report";

import {
  queries,
  queryValues,
  advancedMatching,
  reactPixelOptions,
} from "./helper";

const App = () => {
  const mediaQuery = useMedia(queries, queryValues, "isDesktop");

  ReactPixel.init("3174182765992597", advancedMatching, reactPixelOptions);
  ReactPixel.pageView();
  ReactPixel.fbq("track", "PageView");

  return (
    <>
      <Router>
        <Switch>
          <Route
            path="/roofing-report/:reportId/"
            render={(routerProps) => (
              <RoofingReportPage mediaQuery={mediaQuery} {...routerProps} />
            )}
          />
          <Route
            path="/report/v4/:reportId"
            render={(routerProps) => (
              <V4Report mediaQuery={mediaQuery} {...routerProps} />
            )}
          />

          <Route
            path="/report/:reportId"
            render={(routerProps) => (
              <ReportPage mediaQuery={mediaQuery} {...routerProps} />
            )}
          />
          <Route
            path="/solar/report/:reportId"
            render={(routerProps) => (
              <SolarReport mediaQuery={mediaQuery} {...routerProps} />
            )}
          />

          <Route
            exact
            path="/solar"
            render={(routerProps) => (
              <SolarFunnel mediaQuery={mediaQuery} {...routerProps} />
            )}
          />

          <Route
            exact
            path="/"
            render={(routerProps) => (
              <MultiStepForm mediaQuery={mediaQuery} {...routerProps} />
            )}
          />
          <Route component={NotFoundPage} />
        </Switch>
      </Router>
    </>
  );
};

export default App;
